export const BASE_URL = process.env.NODE_ENV === 'production' ? '/api/v1/' : 'http://localhost:8002/api/v1/';

const AMBIENTE = process.env.REACT_APP_ENV;

const TAG = process.env.REACT_APP_TAG;

const DATA = process.env.REACT_APP_DATA;

const IMG = process.env.REACT_APP_IMG;

export const VERSAO = () => {
    switch (AMBIENTE) {
        case 'production':
            return {
                title: `Versão de Produção - ${TAG} : ${IMG}`,
                data: DATA,
                color: 'rgba(0, 0, 0, 0.7), rgba(28, 28, 28, 0.5), rgba(28, 28, 28, 1)'
            };
        case 'homologation':
            return {
                title: `Versão de Homologação - ${TAG} : ${IMG}`,
                data: DATA,
                color: 'rgba(0, 0, 0, 0.7), rgba(52, 69, 180, 0.5), rgba(52, 69, 180, 0.5)'
            };
        case 'development':
            return {
                title: 'Versão de Desenvolvimento',
                color: 'rgba(0, 0, 0, 0.7), rgba(38, 84, 85, 1), rgba(38, 84, 85, 1)'
            };
        default:
            return {
                title: 'Versão de Desenvolvimento',
                color: 'rgba(0, 0, 0, 0.7), rgba(38, 84, 85, 1), rgba(38, 84, 85, 1)'
            };
    }
}